"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Message = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M0-1h16v16H0z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M10 12l-2 2-2-2H2.182A2.179 2.179 0 0 1 0 9.833V2.167C0 .973.98 0 2.182 0h11.636C15.02 0 16 .973 16 2.167v7.666C16 11.027 15.02 12 13.818 12H10z"
})));
var _default = exports.default = Message;